// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-3838bd3e]{width:320px;height:100px}.replyContent[data-v-3838bd3e] .el-scrollbar__wrap{overflow-x:hidden}.phone[data-v-3838bd3e]{float:right;cursor:pointer}", ""]);
// Exports
module.exports = exports;
